import { render, staticRenderFns } from "./AddShippingModal.vue?vue&type=template&id=8f59cb88&scoped=true&"
import script from "./AddShippingModal.vue?vue&type=script&lang=js&"
export * from "./AddShippingModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f59cb88",
  null
  
)

export default component.exports